<template>
	<v-container class="maxw-40">
		<v-card class="pa-5">
			<v-form class="mb-5" v-model="formIsValid">
				<v-text-field
					label="Email"
					type="text"
					class="form-control"
					:rules="emailValidationRules"
					validate-on-blur
					:value="formValue.email"
					@input="formValue.email = $event"
				/>

				<v-text-field
					label="Password"
					:type="passwordInputType"
					class="form-control"
					v-model="formValue.password"
					:append-icon="showPasswords ? 'mdi-eye-off' : 'mdi-eye'"
					@click:append="showPasswords = !showPasswords"
				/>

				<v-text-field
					label="Confirm Password"
					:type="passwordInputType"
					class="form-control"
					v-model="passwordConfirmation"
					:append-icon="showPasswords ? 'mdi-eye-off' : 'mdi-eye'"
					@click:append="showPasswords = !showPasswords"
				/>

				<div class="d-flex justify-end">
					<v-btn rounded type="submit" @click.prevent="submit" color="primary">Sign up</v-btn>
				</div>
			</v-form>
			<div class="text-center text-muted mt-5">
				Already have an account?
				<router-link :to="signInLink">Sign in</router-link>
			</div>
		</v-card>

		<transition name="fade">
			<app-feedback v-if="errorMessage" class="mt-5" @closed="errorMessage = ''">{{ errorMessage }}</app-feedback>
		</transition>
	</v-container>
</template>

<script>
import appFeedback from '@/components/common/Feedback.vue';
import soilApiService from '../../services/soilApiService';
import { emailValidationRules } from '../../utils/rules';

const initialFormValue = {
	email: '',
	password: '',
};

export default {
	components: {
		appFeedback,
	},
	data() {
		return {
			formIsValid: true,
			errorMessage: '',
			passwordConfirmation: '',
			showPasswords: false,
			formValue: { ...initialFormValue },
			emailValidationRules,
		};
	},
	props: {
		redirect: {
			type: String,
			required: false,
		},
	},
	computed: {
		passwordInputType() {
			return this.showPasswords ? 'text' : 'password';
		},
		passwordShowHideText() {
			return this.showPasswords ? 'Hide passwords' : 'Show passwords';
		},
		signInLink() {
			const link = { name: 'auth-login', params: {} };

			if (this.redirect) {
				link.params.redirect = this.redirect;
			}

			return link;
		},
	},
	methods: {
		async submit() {
			if (!this.formIsValid) {
				return;
			}

			this.errorMessage = '';

			if (this.formValue.password.trim() === '') {
				this.errorMessage = 'You must enter a password.';
				return;
			}

			if (this.formValue.password !== this.passwordConfirmation) {
				this.errorMessage = 'Passwords do not match.';
				return;
			}

			try {
				await soilApiService.register({
					email: this.formValue.email.trim(),
					password: this.formValue.password,
				});

				this.$router.push(this.redirect || '/');
			} catch (error) {
				// TODO: consider better messaging for 409 scenario
				this.errorMessage = 'An error has occurred. Please try again.';
			}
		},
	},
	async created() {
		if (this.$route?.query?.email) {
			this.formValue.email = this.$route.query.email;
		}
	},
};
</script>

<style scoped>
a {
	text-decoration: none;
}
</style>
